import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  async connect () {
    const { default: Dropdown } = await import('bootstrap/js/dist/dropdown')
    this.dropdownInstance = Dropdown.getOrCreateInstance(this.element)
  }
}
